import { useEffect, useState } from 'react';
import { AuthService } from '../service/auth.service';
import AuthContext from './AuthContext';

const AuthProvider = (props) => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [loginUser, setloginUser] = useState({});

    const authService = new AuthService();

    const checkLoggedInUser = () => {
        //const storedUser = localStorage.getItem('um-user');
        //const storedUserData = JSON.parse(storedUser);
        //if (storedUserData) {
        //    setLoggedIn(true);
        //    setloginUser(storedUserData);
        //    return true;
        //}
        //else {
        //    setLoggedIn(false);
        //    setloginUser({});
        //    return false;
        //}


        const tokenExpireTime = localStorage.getItem('um-token-expire-time');
        if (tokenExpireTime) {
            const date = new Date(tokenExpireTime * 1000);
            if (date > new Date()) {
                setLoggedIn(true);

                const storedUser = localStorage.getItem('um-user');
                const storedUserData = JSON.parse(storedUser);
                if (storedUserData) {
                    setloginUser(storedUserData);
                }
                return true;
            }
            else {
                setLoggedIn(false);
                setloginUser({});
                return false;
            }
        }
        else {
            setLoggedIn(false);
            setloginUser({});
            return false;
        }
    };

    return (
        <AuthContext.Provider
            value={{
                login: async (email, pass) => {
                    const response = await authService.logininfo(email, pass, false);
                    if (response.data.isSuccess) {
                        console.log("Login attempt was successfull for the email : " + email);

                        setLoggedIn(true);
                        setloginUser(response.data.user);
                        localStorage.setItem('um-user', JSON.stringify(response.data.user));
                        localStorage.setItem('um-token', response.data.token);
                        localStorage.setItem('um-token-expire-time', response.data.tokenExpirationTime);                        
                        return { isSuccess: response.data.isSuccess, message: response.data.message };
                    }
                    else {
                        console.log("Login attempt was unsuccessfull for the email : " + email);
                        localStorage.removeItem('um-user');
                        localStorage.removeItem('um-token');
                        localStorage.removeItem('um-token-expire-time'); 
                        return { isSuccess: response.data.isSuccess, message: response.data.message };;
                    }
                },
                logout: () => {
                    setLoggedIn(false);
                    setloginUser({});
                    localStorage.removeItem('um-user');
                    localStorage.removeItem('um-token');
                    localStorage.removeItem('um-token-expire-time');
                },
                checkLoggedIn: () => {
                    return checkLoggedInUser();
                },
                loggedIn,
                loginUser
            }}>
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;
